import { useFaireDirectBrandForVisitorQuery } from "@faire/deprecated-retailer-visitor-shared/app/_lib/faire-direct-visitor/faire-direct/useFaireDirectBrandForVisitorQuery";

import { useFaireDirectInfo } from "../useFaireDirectInfo/useFaireDirectInfo";
import { useIsFaireDirectActiveInLoggedOut } from "../useIsFaireDirectActiveInLoggedOut/useIsFaireDirectActiveInLoggedOut";

export const useFaireDirectBrand = () => {
  const {
    faireDirectBrandToken: brandTokenFromInfo,
    faireDirectBrandAlias: brandAliasFromInfo,
  } = useFaireDirectInfo();
  const faireDirectBrandToken = brandTokenFromInfo ?? "";
  const faireDirectBrandAlias = brandAliasFromInfo ?? "";

  /**
   * Checking whether Faire Direct is 'active' is derived from being on `/direct` (as a logged-out user)
   * or having the `fdb` query parameter appended. This check is only reliable and meaningful in the logged-out
   * state because in logged-in Faire Direct presence is determined through the relevant active incentive.
   */
  const isFaireDirectActiveInLoggedOut = useIsFaireDirectActiveInLoggedOut();

  const faireDirectBrand = useFaireDirectBrandForVisitorQuery(
    faireDirectBrandToken,
    isFaireDirectActiveInLoggedOut
  );

  return {
    faireDirectBrandToken,
    isFaireDirectActiveInLoggedOut,
    faireDirectBrand,
    faireDirectBrandAlias,
  };
};
